import {
  HeartPulse, ShieldPlus, Syringe, Brain, Salad, Baby, Megaphone, Leaf,
  Activity, Droplets, BookOpen, type LucideIcon,
} from 'lucide-react'

export interface CategoryVisual {
  Icon: LucideIcon
  /** 图标底色 */
  bg: string
  /** 图标颜色 */
  fg: string
}

/** 关键词 → 视觉样式映射（按分类名匹配） */
const NAMED_MAP: Array<{ keys: string[]; visual: CategoryVisual }> = [
  { keys: ['慢病'], visual: { Icon: HeartPulse, bg: 'bg-red-50', fg: 'text-red-500' } },
  { keys: ['传染'], visual: { Icon: ShieldPlus, bg: 'bg-orange-50', fg: 'text-orange-500' } },
  { keys: ['疫苗', '免疫'], visual: { Icon: Syringe, bg: 'bg-blue-50', fg: 'text-blue-500' } },
  { keys: ['心理'], visual: { Icon: Brain, bg: 'bg-purple-50', fg: 'text-purple-500' } },
  { keys: ['营养', '膳食', '食品'], visual: { Icon: Salad, bg: 'bg-green-50', fg: 'text-green-600' } },
  { keys: ['妇幼', '母婴', '儿童'], visual: { Icon: Baby, bg: 'bg-pink-50', fg: 'text-pink-500' } },
  { keys: ['公告'], visual: { Icon: Megaphone, bg: 'bg-amber-50', fg: 'text-amber-500' } },
  { keys: ['中医', '养生'], visual: { Icon: Leaf, bg: 'bg-teal-50', fg: 'text-teal-600' } },
  { keys: ['急救'], visual: { Icon: Activity, bg: 'bg-rose-50', fg: 'text-rose-500' } },
  { keys: ['血液', '献血'], visual: { Icon: Droplets, bg: 'bg-sky-50', fg: 'text-sky-500' } },
]

/** 兜底循环配色（未命中命名映射时按索引取） */
const FALLBACK_PALETTE: CategoryVisual[] = [
  { Icon: BookOpen, bg: 'bg-green-50', fg: 'text-green-600' },
  { Icon: BookOpen, bg: 'bg-blue-50', fg: 'text-blue-500' },
  { Icon: BookOpen, bg: 'bg-purple-50', fg: 'text-purple-500' },
  { Icon: BookOpen, bg: 'bg-orange-50', fg: 'text-orange-500' },
  { Icon: BookOpen, bg: 'bg-pink-50', fg: 'text-pink-500' },
  { Icon: BookOpen, bg: 'bg-teal-50', fg: 'text-teal-600' },
]

/** 按分类名匹配金刚区图标与配色，未命中按索引取兜底色 */
export const getCategoryVisual = (name: string, index = 0): CategoryVisual => {
  for (const entry of NAMED_MAP) {
    if (entry.keys.some(k => name.includes(k))) return entry.visual
  }
  return FALLBACK_PALETTE[index % FALLBACK_PALETTE.length]
}
